import 'whatwg-fetch'
const gigya = require('gigya');

class GigyaWrapper {
  static get USE_STATUS_NOMAL() {
    return 2;
  }
  static get USE_STATUS_WITHDRAW() {
    return 9;
  }

  constructor () {
    this.gigya = gigya
    window.onAfterScreenLoadWeb = function(event) {
      if (event.currentScreen === 'gigya-login-screen' || event.currentScreen === 'gigya-register-screen' || event.currentScreen === 'gigya-update-profile-screen') {
        // NOTE: onAfterScreenLoadイベントが実行された際、window.onAfterScreenLoadWebが実行される
        // https://cdmproject.backlog.com/view/COCRECO_ID_DEV-37
        // self.loadingStop();
        $('#loading_modal').remove();
      }
    }
    window.onAfterSubmitWeb = function(event) {
      if (event.screen === 'gigya-update-profile-screen') {
        const message = $('<p>').text("プロフィールを変更しました").html().replace(/\n/g, '<br>').replace(/\+/g, ' ');
        const alertInfo = $(".dynmsg.alert.alert-info");
        alertInfo.find('.message').html(message);
        alertInfo.show();
        setTimeout('closeMessage()', 1500);
      }
    };
    window.onSentVerificationCode = function() {
      const message = $('<p>').text("メールをお送りしました").html().replace(/\n/g, '<br>').replace(/\+/g, ' ');
      const alertInfo = $(".dynmsg.alert.alert-info");
      alertInfo.find('.message').html(message);
      alertInfo.show();
      setTimeout('closeMessage()', 1500);
    };
  }

  alertMessage(msg) {
    const message = $('<p>').text(msg).html().replace(/\n/g, '<br>').replace(/\+/g, ' ');
    const alertInfo = $(".dynmsg.alert.alert-info");
    alertInfo.find('.message').html(message);
    alertInfo.show();
    setTimeout('closeMessage()', 3000);
  }

  debug(msg) {
    if (process.env.DEBUG) {
      console.log(msg);
    }
  }

  signInPath() {
    const firstPathSegment = window.location.pathname.split('/')[1];
    const fetchUrl = firstPathSegment === 'akaiyume' ? `/${firstPathSegment}/member/sign_in` : '/member/sign_in';
    return fetchUrl;
  }

  redirectTo(url) {
    if (!url) { url = '/' }
    if (url.indexOf('/') == 0) {
      url = `${location.origin}${url}`;
    }

    if (process.env.DEBUG && process.env.REDIRECT_OFF) {
      alert(`debugしやすいようにリダイレクトしないようにしています。consoleに表示されるredirect_toを確認してください。`);
      this.debug(`redirect_to: ${url}`);
    } else {
      location.href = url;
    }
  }

  loadingStart() {
    if ($('#loading_modal').length <= 0) {
      let html = `<div id="loading_modal"><div class="loader">Loading...</div></div>`;
      $("body").append(html);
    }
  }

  loadingStop() {
    $('#loading_modal').remove();
  }

  gigyaWithdraw() {
    let self = this;

    self.loadingStart();

    self.gigya.accounts.getAccountInfo({
      include: 'subscription',
      callback: async function(res) {
        const mailMagazines = res.subscriptions;
        console.log(res)
        gigya.accounts.getJWT({
          callback: async function(jwtRes) {
            let serverResponse = {}
            if (jwtRes.errorCode === 0) {
              serverResponse = await self.withdrawClipkitUser(res, jwtRes);
              const updateAccountInfoParams = {
                subscriptions: {},
                data: {
                  useService: {
                    cocreco: {
                      useStatus: GigyaWrapper.USE_STATUS_WITHDRAW,
                      endDate: new Date().toISOString()
                    }
                  }
                },
                callback: async function(response) {
                  self.debug(response);
                  if (response.errorCode === 0) {
                    self.gigya.accounts.resetSitePreferences();
                    self.debug("退会完了しました")
                  } else {
                    alert("退会に失敗しました")
                    console.log("setAccountInfo Error:", response.errorCode)
                  }
                }
              }
              for (const mailMagazine in mailMagazines) {
                if (mailMagazine.match(/^cocreco/)) {
                  updateAccountInfoParams['subscriptions'][mailMagazine] = {
                    email: {
                      isSubscribed: false
                    }
                  }
                }
              }
              self.gigya.accounts.setAccountInfo(updateAccountInfoParams);
            } else {
              console.log("getJWT Error: " + jwtRes.errorCode)
            }
            self.gigya.accounts.addEventHandlers({
              onLogout: async function(event) {
                if (serverResponse) {
                  self.redirectTo(serverResponse.redirect_path);
                } else {
                  self.historyBack('/');
                }
              }
            });
          }
        });
      },
    });
  }

  gigyaSignIn (screen_name='gigya_user_login', custom_callback=null, isClipkitSessionCheck=true) {
    let self = this;

    self.loadingStart();
    self.gigya.accounts.verifyLogin({
      callback: async function(response) {
        self.debug(response);
        if (response.errorCode !== 0) {
          if (screen_name == 'gigya_user_register') {
            self.debug("Unsigned. Loading... ScreenRegister");
            self.screenRegister('gigya_user_register');
          } else if (screen_name == 'gigya_user_login') {
            self.debug("Unsigned. Loadding... ScreenLogin");
            self.screenLogin('gigya_user_login');
          } else {
            self.redirectTo(self.signInPath())
          }
        } else {
          self.debug("Signed");
          if (isClipkitSessionCheck) {
            self.gigya.accounts.getJWT({
              callback: async function(jwtRes) {
                if (jwtRes.errorCode === 0) {
                  const serverResponse = await self.createClipkitSession(response, jwtRes);
                  if (custom_callback != null) {
                    custom_callback.call(this, serverResponse, false);
                  } else {
                    self.redirectTo(serverResponse.redirect_path);
                  }
                } else {
                  console.log("getJWT Error: " + jwtRes.errorCode)
                }
              }
            });
          } else {
            if (custom_callback != null) {
              custom_callback.call(this, {}, false);
            } else {
              self.historyBack('/member/mypage');
            }
          }
        }
      }
    });

    self.gigya.accounts.addEventHandlers({
      onLogin: async function(response) {
        self.loadingStart();
        gigya.accounts.getJWT({
          callback: async function(jwtRes) {
            if (jwtRes.errorCode === 0) {
              let isNewMemberRegistration = true
              if (response?.data?.useService?.cocreco?.useStatus &&
                  response?.data?.useService?.cocreco?.useStatus == GigyaWrapper.USE_STATUS_NOMAL) {
                isNewMemberRegistration = false;
              }
              if (isNewMemberRegistration) {
                const updateAccountInfoParams = {
                  data: {
                    useService: {
                      cocreco: {
                        useStatus: GigyaWrapper.USE_STATUS_NOMAL,
                        startDate: new Date().toISOString()
                      }
                    }
                  },
                  callback: async function(setAccountRes) {
                    self.debug(setAccountRes);
                    if (setAccountRes.errorCode === 0) {
                      self.debug("setAccountInfoにて登録完了")
                      const serverResponse = await self.createClipkitSession(response, jwtRes, isNewMemberRegistration);
                      if (custom_callback != null) {
                        custom_callback.call(this, serverResponse, isNewMemberRegistration);
                      } else {
                        self.redirectTo(serverResponse.redirect_path);
                      }
                    } else {
                      console.log("setAccountInfo Error:", setAccountRes.errorCode);
                    }
                  }
                }
                self.gigya.accounts.setAccountInfo(updateAccountInfoParams);
              } else {
                let serverResponse = {}
                serverResponse = await self.createClipkitSession(response, jwtRes);
                if (custom_callback != null) {
                  custom_callback.call(this, serverResponse);
                } else {
                  self.redirectTo(serverResponse.redirect_path);
                }
              }
            } else {
              console.log("getJWT Error: " + jwtRes.errorCode)
            }
          }
        });
      }
    });
  }

  // NOTE: TEST用URL => /member/sign_in?jwt_dest=iqform&nexturl=https://stg-form.contentdata.co.jp/g/cocreco/wc3de9fu4rrk/
  toIqForm(nexturl) {
    let self = this;
    self.loadingStart();

    const permitUrls = [
      'voc-test.kodansha.co.jp', 'voc.kodansha.co.jp',
      'stg-form.contentdata.co.jp', 'form.contentdata.co.jp'
    ];
    let uri = new URL(nexturl);
    if (!permitUrls.includes(uri.host)) {
      alert('不正なURLアクセスになります。');
      self.redirectTo('/');
      return null;
    }

    self.gigya.accounts.getJWT({
      callback: function(response) {
        if (response.errorCode === 0) {
          let id_token = response.id_token;
          let form_html = `
          <form action="${uri.origin}${uri.pathname}?${uri.searchParams.toString()}" name="form-jwt" method="post" style="display:none;">
          <input type="hidden" name="id_token" value="${id_token}" />
          </form>
          `;
          $('body').append(form_html);
          document.forms['form-jwt'].submit();
        } else {
          self.debug("Failed to get jwt")
          self.redirectTo('/');
        }
      }
    });
  }

  // NOTE: TEST用URL => /member/sign_in?jwt_dest=idlounge&nexturl=/mypage
  toIdlounge(nexturl) {
    let self = this;
    self.loadingStart();

    self.gigya.accounts.getJWT({
      callback: function(response) {
        if (response.errorCode === 0) {
          let id_token = response.id_token;
          // NOTE: nexturl = "/mypage"
          let form_html = `
          <form action="${process.env.ID_LOUNGE_URL}/idloungelogin?nexturl=${nexturl}" name="form-jwt" method="post" style="display:none;">
          <input type="hidden" name="id_token" value="${id_token}" />
          </form>
          `;
          $('body').append(form_html);
          document.forms['form-jwt'].submit();
        } else {
          self.debug("Failed to get jwt")
          self.redirectTo('/');
        }
      }
    });
  }

  // NOTE: TEST用URL => /member/sign_in?jwt_dest=moala&redirect_url=https://stg-s-cocreco.kodansha.co.jp
  toMoala(nexturl) {
    let self = this;
    self.loadingStart();

    // TODO: MOALAのドメインが入る想定
    const permitUrls = [
      's-cocreco.kodansha.co.jp', 'stg-s-cocreco.kodansha.co.jp'
    ];
    let uri = new URL(nexturl);
    if (!permitUrls.includes(uri.host)) {
      alert('不正なURLアクセスになります。');
      self.redirectTo('/');
      return null;
    }

    self.redirectTo(nexturl);
  }

  // NOTE: TEST用URL => /member/sign_in?jwt_dest=ehonnavi&redirect_url=https://dev.ehonnavi.net
  toEhonnavi(nexturl) {
    let self = this;
    self.loadingStart();

    const permitUrls = [
      'dev.ehonnavi.net', 'www.ehonnavi.net'
    ];
    let uri = new URL(nexturl);
    if (!permitUrls.includes(uri.host)) {
      alert('不正なURLアクセスになります。');
      self.redirectTo('/');
      return null;
    }
    self.redirectTo(nexturl);
  }

  screenLogin(name, lang='ja') {
    this.gigya.accounts.showScreenSet({
      screenSet: 'Cocreco-RegistrationLogin',
      startScreen: 'gigya-login-screen',
      containerID: name,
      lang: lang
    });
  }

  screenRegister(name, lang='ja') {
    this.gigya.accounts.showScreenSet({
      screenSet: 'Cocreco-RegistrationLogin',
      startScreen: 'gigya-register-screen',
      containerID: name,
      lang: lang
    });
  }

  screenProfileUpdate(name, lang='ja') {
    this.gigya.accounts.showScreenSet({
      screenSet: 'Cocreco-ProfileUpdate',
      startScreen: 'gigya-update-profile-screen',
      containerID: name,
      lang: lang
    });
  }

  screenResetPassword(name, lang='ja') {
    let self = this;
    this.gigya.accounts.showScreenSet({
      screenSet: 'IDLounge-RegistrationLogin',
      startScreen: 'gigya-reset-password-screen',
      containerID: name,
      lang: lang
    });
  }

  csrfToken() {
    return $('meta[name="csrf-token"]').attr('content');
  }

  defaultHeaders() {
    return {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": this.csrfToken(),
      "X-Requested-With": "XMLHttpRequest"
    }
  }

  async createClipkitSession(params, jwtResponse, isNewMember=false) {
    const err = new Error();
    let self = this;

    try {
      let queryObject = self.makeQueryObject(window.location.search);
      let redirect_url = queryObject["redirect_url"];
      if (queryObject["nexturl"]) {
        redirect_url = queryObject["nexturl"];
      }
      const firstPathSegment = window.location.pathname.split('/')[1];
      const fetchUrl = firstPathSegment === 'akaiyume' ? `/${firstPathSegment}/member/create_session` : '/member/create_session';

      const response =  await fetch(fetchUrl, {
        method: "POST",
        cache: "no-cache",
        body: JSON.stringify({
          uid: params.UID,
          jwt_dest: queryObject["jwt_dest"],
          redirect_url: redirect_url,
          id_token: jwtResponse.id_token,
          new_member: isNewMember
        }),
        headers: self.defaultHeaders()
      });

      if (!response.ok) {
        err.message = 'response.ok failure';
        throw err;
      }
      let body = await response.json();
      if (body.signed) {
        self.debug("Signin Success")
      } else {
        self.debug("Signin Application Error")
      }
      if (body.to_additonal_profile_member) {
        // TODO: Gigyaのログアウト処理を入れるかも
      }
      return body;

    } catch (error) {
      console.log("createClipkitSession Http Error")
      console.log(error.message)
      console.log(error.stack)
    }
  }

  async withdrawClipkitUser(params, jwtResponse) {
    const err = new Error();
    let self = this;

    self.loadingStart();
    try {
      const response =  await fetch('/member', {
        method: "DELETE",
        cache: "no-cache",
        body: JSON.stringify({
          uid: params.UID,
          email: params.profile.email,
          id_token: jwtResponse.id_token
        }),
        headers: this.defaultHeaders()
      });

      if (!response.ok) {
        err.message = 'response.ok failure';
        throw err;
      }
      let body = await response.json();
      if (body.signed) {
        this.debug("Withdraw Application Error")
      } else {
        this.debug("Withdraw Success")
      }
      return body;

    } catch (error) {
      console.log("withdrawClipkitUser Http Error")
      console.log(error.message)
      console.log(error.stack)
    }
  }

  logout() {
    let self = this;
    const err = new Error();

    self.loadingStart();
    self.gigya.accounts.logout({
      callback: async function(response){
        if (response.errorCode == 0) {
          try {
            const firstPathSegment = window.location.pathname.split('/')[1];
            const fetchUrl = firstPathSegment === 'akaiyume' ? `/${firstPathSegment}/member/destroy_session` : '/member/destroy_session';
            const response = await fetch(fetchUrl, {
              method: "POST",
              cache: "no-cache",
              headers: self.defaultHeaders()
            });
            if (!response.ok) {
              err.message = 'response.ok failure';
              throw err;
            }
            let body = await response.json();
            if (body.signout) {
              self.debug("Signout cocreco");
              self.redirectTo(body.return_path);
            } else {
              self.debug("Signin cocreco");
            }
          } catch (error) {
            console.log("accounts.logout Http Error");
            console.log(error.message)
            console.log(error.stack)
          }
        } else {
          console.log("accounts.logout Gigya Error");
          self.redirectTo('/');
        }
      }
    });
  }

  userMenuToggle() {
    this.gigya.accounts.verifyLogin({
      include: 'data',
      callback: function(res) {

        console.log(res.errorCode);

        $('.js-with_girls_entry').hide();
        $('.js-with_user_menu li').hide();
        if (res.errorCode === 0) {
          $('.js-with_user_menu li').each(function(){
            if (res.data.useService.cocreco.useStatus == 1) {
              if ($(this).hasClass('js-user_edit') || $(this).hasClass('js-sign_out')) {
                $(this).show();
              }
              $('.js-with_girls_entry').show();
            } else if (res.data.useService.cocreco.useStatus == 2) {
              if ($(this).hasClass('js-mypage') || $(this).hasClass('js-sign_out')) {
                $(this).show();
              }
            }
          });
        } else {
          $('.js-with_user_menu li').each(function(){
            if ($(this).hasClass('js-sign_in') || $(this).hasClass('js-register')) {
              $(this).show();
            }
          });
        }
      }
    });
  }

  historyBack(url) {
    this.loadingStart();
    const self = this;
    const ref = document.referrer;
    let isSiteDomain = false;
    const hostname = new RegExp(location.hostname,"i");
    if (ref.match(hostname)) {
      isSiteDomain = true;
    }

    if (isSiteDomain) {
      try {
        self.redirectTo(ref)
      } catch {
        setTimeout(function(){
          self.redirectTo(url);
        }, 100);
      }
    } else {
      self.redirectTo(url);
    }
    return false;
  }

  makeQueryObject(queryString){
    let queryObject = new Object();
    if(queryString){
      queryString = queryString.substring(1);
      let parameters = queryString.split('&');

      for (let i = 0; i < parameters.length; i++) {
        let element = parameters[i].split('=');

        let paramName = decodeURIComponent(element[0]);
        let paramValue = decodeURIComponent(element[1]);

        queryObject[paramName] = paramValue;
      }
    }

    return queryObject;
  }

  // NOTE: 都都道府は不変で、サーバサイドのドメインロジックとすると負荷かかるので直接view側に記載
  prefectureLabel(code) {
    const prefecture = [
      null,
      '北海道',
      '青森県',
      '岩手県',
      '宮城県',
      '秋田県',
      '山形県',
      '福島県',
      '茨城県',
      '栃木県',
      '群馬県',
      '埼玉県',
      '千葉県',
      '東京都',
      '神奈川県',
      '新潟県',
      '富山県',
      '石川県',
      '福井県',
      '山梨県',
      '長野県',
      '岐阜県',
      '静岡県',
      '愛知県',
      '三重県',
      '滋賀県',
      '京都府',
      '大阪府',
      '兵庫県',
      '奈良県',
      '和歌山県',
      '鳥取県',
      '島根県',
      '岡山県',
      '広島県',
      '山口県',
      '徳島県',
      '香川県',
      '愛媛県',
      '高知県',
      '福岡県',
      '佐賀県',
      '長崎県',
      '熊本県',
      '大分県',
      '宮崎県',
      '鹿児島県',
      '沖縄県',
    ];
    return prefecture[Number(code)];
  }
}

export { gigya, GigyaWrapper }
